module.exports = __webpack_public_path__ + "img/activitySquare.08467142.svg";